import { useAuthStore } from '../store/authStore'
import { formatCurrency } from '../utils/currency'

export function useCurrency() {
  const currency = useAuthStore((s) => s.tenant?.currency ?? 'NGN')

  return {
    currency,
    format: (amount: number) => formatCurrency(amount, currency),
  }
}
